import { render, staticRenderFns } from "./modalComprovanteVariavel.vue?vue&type=template&id=f9421c1a&"
import script from "./modalComprovanteVariavel.vue?vue&type=script&lang=js&"
export * from "./modalComprovanteVariavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports